import '../../../../node_modules/@glidejs/glide/dist/css/glide.core.css'
import Glide from '@glidejs/glide'

const postCarousel = {
  el: '',
  init() {
    this.el = $q('.post-carousel')

    if (!this.el.first) return

    this.el.loop(carousel => {
      new Glide(carousel, {
        type: 'carousel',
        perView: 4,
        gap: 0
        // breakpoints: {
        //   1200: {
        //     perView: 1,
        //     focusAt: 'center'
        //   }
        // }
      }).mount()
    })
  }
}
export default postCarousel
